export const ROOT = 'StepOne/form/adsRepublish';

export const FETCH_ADS_REPUBLISH_REQUEST = `${ROOT}/FETCH_ADS_REPUBLISH_REQUEST`;
export const FETCH_ADS_REPUBLISH_FAILURE = `${ROOT}/FETCH_ADS_REPUBLISH_FAILURE`;
export const FETCH_ADS_REPUBLISH_SUCCESS = `${ROOT}/FETCH_ADS_REPUBLISH_SUCCESS`;

export const CLEAR_ADS_REPUBLISH_DATA = `${ROOT}/CLEAR_ADS_REPUBLISH_DATA`;